import PropTypes from 'prop-types'
import { Checkbox } from '@components/ui/checkbox'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasCheckbox = ({
  checked,
  onChange,
  disabled,
  label,
  id,
  name,
  className,
  value,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => {
  const checkboxId = id || name
  const handleChange = (checkedState) => {
    if (onChange) {
      onChange({ target: { type: 'checkbox', checked: checkedState, value, name } })
    }
  }
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Checkbox id={checkboxId} checked={checked} onCheckedChange={handleChange} disabled={disabled} {...props} />
      {label && (
        <Label htmlFor={checkboxId} className='text-sm cursor-pointer'>
          {label}
        </Label>
      )}
    </div>
  )
}

AdasCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.any
}
